export default __webpack_public_path__ + "static/media/box.fc33cc96.png";